import { env } from "./env"
import "./graft"

const MDRouter = {
    // 去众筹更新详情
    goUpdateDetail: function (id, query, url) {
        const queryString = getUrlParamsString(query)
        // eslint-disable-next-line no-undef
        graft.app({
            functionName: "openController",
            functionParams: `md://update_detail?id=${id}${queryString ? "&" + queryString : ''}`,
            webFun: () => {
                //小程序
                if (env.isWxApp()) {
                    MDRouter.MinaRouter('UpdateDetail', {
                        id: id,
                        query: query
                    })
                } else {
                    window.location.href = url
                }
            }
        })
    },
    // 去众筹详情
    goProInfo: function (id, query, url) {
        const queryString = getUrlParamsString(query)
        // eslint-disable-next-line no-undef
        graft.app({
            functionName: "openController",
            functionParams: `md://project?id=${id}${queryString ? "&" + queryString : ''}`,
            webFun: () => {
                //小程序
                if (env.isWxApp()) {
                    MDRouter.MinaRouter('ProInfo', {
                        pro_id: id,
                        query: query
                    })
                } else {
                    window.location.href = url
                }
            }
        })
    },
    // ****************** 电商 ********************
    // 去电商详情
    goMallInfo: function (id, query, url) {
        const queryString = getUrlParamsString(query)
        // eslint-disable-next-line no-undef
        graft.app({
            functionName: "openController",
            functionParams: `md://mall_detail?id=${id}${queryString ? '&' + queryString : ''}`,
            webFun: () => {
                //小程序
                if (env.isWxApp()) {
                    MDRouter.MinaRouter('MinaWebview', {
                        url: url
                    })
                } else {
                    window.location.href = url
                }
            }
        })
    },
    // 去创意详情
    goIdeaInfo: function(id, query, url) {
        const queryString = getUrlParamsString(query)
        // eslint-disable-next-line no-undef
        graft.app({
            functionName: "openController",
            functionParams: `md://idea?id=${id}${queryString ? '&' + queryString : ''}`,
            webFun: () => {
                //小程序
                if (env.isWxApp()) {
                    MDRouter.MinaRouter('IdeaDetail', {
                        idea_id: id,
                        query: query
                    })
                } else {
                    window.location.href = url
                }
            }
        })
    },
    // 去抽卡详情
    goLuckycardsInfo: function(id, query, url) {
        // eslint-disable-next-line no-undef
        graft.app({
            functionName: "openController",
            functionParams: url,
            webFun: () => {
                //小程序
                if (env.isWxApp()) {
                    MDRouter.MinaRouter('LuckycardsDetail', {
                        id: id
                    })
                } else {
                    window.location.href = url
                }
            }
        })
    },
    // 去动态详情
    goFeedInfo: function(id, query, url) {
        const queryString = getUrlParamsString(query)
        // eslint-disable-next-line no-undef
        graft.app({
            functionName: "openController",
            functionParams: `md://post_detail?id=${id}${queryString ? "&" + queryString : ''}`,
            webFun: () => {
                window.location.href = url
            }
        })
    },
    // 去话题详情
    goTopicInfo: function(id, query, url) {
        const queryString = getUrlParamsString(query)
        // eslint-disable-next-line no-undef
        graft.app({
            functionName: "openController",
            functionParams: `md://trend_detail?id=${id}${queryString ? "&" + queryString : ''}`,
            webFun: () => {
                window.location.href = url
            }
        })
    },
    MinaRouter: function(type, query) {
        if (env.isWxApp()) {
            let link_url = ''
            const queryString = getUrlParamsString(query)
            switch (type) {
                case "ProInfo": // 众筹详情
                    link_url = '/pages/project-detail/project-detail'
                    break;
                case "ProjectList": // 众筹项目列表
                    link_url = '/pages/project_list/project_list'
                    break;
                case "UpdateDetail": // 众筹更新详情
                    link_url = '/pages/projectPages/update-detail/update-detail'
                    break;
                case "IdeaDetail": // 创意详情
                    link_url = '/pages/ideaPages/idea_detail/idea_detail'
                    break;
                case "LuckycardsDetail": // 抽卡详情
                    link_url = '/pages/luckycards/detail/detail'
                    break;  
                case "LuckycardsCollectList": // 抽卡合集列表
                    link_url = '/pages/luckycards/collect_list/collect_list'
                    break;
                case "MinaWebview": // 小程序内嵌
                    link_url = '/pages/content/content';
                    break;
                default: 
                    link_url = '/pages/index/index'
            }
            // eslint-disable-next-line no-undef
            wx.miniProgram.navigateTo({
                url: link_url + (queryString ? '?' + queryString : '')
            })
        }
    },
    Link: function (url) {
        // eslint-disable-next-line no-undef
        graft.app({
            functionName: "openController",
            functionParams: url,
            webFun: () => {
                window.location.href = url
            },
        });
    },
}
export default MDRouter


// 匹配URL及内链 
export const getUrlType = function(url) {
    // 众筹详情正则
    let regPro = /^http[s]?:\/\/(testm|m|zhongchou|testzhongchou).*modian[inc]?.*?\.com\/(item|project)\/([0-9]+).*?$/;
    // 商品详情正则
    let regMall = /^http[s]?:\/\/(testm|m).*modian[inc]?.*?\.com\/(product)\/([0-9]+).*?$/;
    // 更新详情正则
    let regUpdate = /^http[s]?:\/\/(testm|m|zhongchou|testzhongchou).*modian[inc]?.*?\.com\/(project\/update\/detail|p\/update_detail)\/([0-9]+).*?$/;
    // 创意详情正则
    let regIdea = /^http[s]?:\/\/(testm|m).*modian[inc]?.*?\.com\/(idea)\/([0-9]+).*?$/;
    // 抽卡机详情
    let regLuckyCardDetail = /^http[s]?:\/\/(testm|m).*modian[inc]?.*?\.com\/luckycards\/fastsell\/detail\/([0-9]+).*?$/;
    // 动态详情正则
    let regPost = /^http[s]?:\/\/(m|zhongchou).*modian[inc]?.*?\.com\/(dongtai\/detail|common\/feed\/[0-9]).*?$/;
    // 话题详情正则
    let regTopic = /^http[s]?:\/\/(m|zhongchou).*modian[inc]?.*?\.com\/(topic\/topic_list|common\/topic\/[0-9]).*?$/;

    if (regPro.test(url) ||
      url.indexOf('md://project') > -1) { //项目详情页
      return 'ProInfo'
    }
    if (regMall.test(url) ||
      url.indexOf('md://mall_detail') > -1) { //电商详情页
      return 'MallInfo'
    }
    if (regUpdate.test(url) ||
      url.indexOf('md://update_detail') > -1) { //更新详情页
      return 'UpdateDetail'
    }
    if (regIdea.test(url) ||
      url.indexOf('md://idea') > -1) { //创意
      return 'IdeaDetail'
    }
    if (regLuckyCardDetail.test(url)) { // 抽卡机详情
      return 'LuckycardsDetail'
    }
    if (regPost.test(url) ||
      url.indexOf('md://post_detail') > -1) { // 动态
      return 'FeedInfo'
    }
    if (regTopic.test(url)) { // 话题详情
        return 'TopicInfo'
    }
}

// 将【字符串参数】转换为map格式
export const getUrlParamsMapFromString = function (paramsString) {
    const params = {}
    paramsString.split('&').forEach(queryItem => {
        const [key, value] = queryItem.split('=');
        if (key) {
            params[decodeURIComponent(key)] = decodeURIComponent(value || '');
        }
    })
    return params;
}

// 将map【query参数】转换为字符串格式
export const getUrlParamsString = function(params) {
    if (typeof params != 'object') return ''
    let arr = [];
    for (const key in params) {
        arr.push(`${key}=${params[key]}`)
    }
    return arr.length ? arr.join('&') : ''
}

// 获取url?后参数，输出为map格式
export const getUrlParamsMapFromUrl = function(url) {
    if (url.indexOf('?') !== -1) {
        return getUrlParamsMapFromString(url.split('?')[1])
    }
    return {}
}

//---------------参数解析-----------------
export const getIDParams = function(url) {
    // const id = url.match(/\/(\d+)\.*?/);
    const id = url.match(/\/(\d+)(?:(\?|.html)|$)/)
    return id ? id[1] : undefined
}

// 识别链接
export const urlFormatToJump = function(url) {
    var type = getUrlType(url)
    let paramsMap = getUrlParamsMapFromUrl(url);
    let id = getIDParams(url) || paramsMap.id
    switch(type) {
        case 'ProInfo': 
            MDRouter.goProInfo(id, paramsMap, url);
            break;
        case 'MallInfo':
            MDRouter.goMallInfo(id, paramsMap, url);
            break;
        case 'UpdateDetail':
            MDRouter.goUpdateDetail(id, paramsMap, url);
            break;
        case 'IdeaDetail':
            MDRouter.goIdeaInfo(id, paramsMap, url);
            break;
        case 'LuckycardsDetail':
            MDRouter.goLuckycardsInfo(id, paramsMap, url);
            break;
        case 'FeedInfo':
            MDRouter.goFeedInfo(id, paramsMap, url);
            break;
        case 'TopicInfo':
            MDRouter.goTopicInfo(id, paramsMap, url);
            break;
        default:
            MDRouter.Link(url);  
    }
}